import Input from '@material-ui/core/Input';
import { withStyles } from "@material-ui/core/styles";
import { forwardRef } from 'react';

const styles = theme => ({
    inputStyle: {
        backgroundColor: theme.ComponentHeader,
        color: theme.TextColor,
        fontSize: theme.textFontSize,
        height: '94%',
        maxWidth: 100,
        boxSizing: "border-box",
        border: `1px solid ${theme.iconColor}`,
        borderRadius: 2,
        marginTop: 6,
        '&::before, &::after, & input': {
            border: "none !important",
            height: '100%'
        },
        '& input[type="number"]': {
            color: `${theme.TextColor} !important`,
            padding: 5
        }
    }
});

const NumericEditor = forwardRef((props, ref) => {
    const { classes, value, onChange } = props;

    const onKeyPress = (event) => {
        if (!((event.charCode == 8 || event.charCode == 0) ? null : (event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46))) {
            event.preventDefault();
        }
    };   

    return (
        <Input
            autoFocus
            inputRef={ref}
            classes={{
                root: classes.inputStyle
            }}
            type="number"
            inputProps={{
                min: 0,
                onKeyPress: onKeyPress,
                value: isNaN(parseInt(value)) ? "" :  value
            }}
            onChange={onChange}
        />
    );
});

export default withStyles(styles)(NumericEditor);
